import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "gw-brightness1",
  "use": "gw-brightness1-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"gw-brightness1\"><path fill=\"none\" d=\"M0 0h24v24H0Z\" /><path d=\"M19.07 4.92c3.9 3.9 3.9 10.23 0 14.14-3.91 3.9-10.24 3.9-14.15 0a10 10 0 0 1 0-14.15C8.82 1 15.15 1 19.06 4.91\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol